import { DateTimeFormatterConfig } from './localization.model';

/**
 * Formatting defaults
 *
 * Use this constants to setup format default settings regardless the language
 * selected. IMPORTANT: if we want to customize these settings per language, then
 * it is better to create a mapper in business.
 */

// For native formatting (based on native Intl)
export const defaultDateFormatConfig: DateTimeFormatterConfig = { dateStyle: undefined }; // Let local decide
export const defaultTimeFormatConfig: DateTimeFormatterConfig = { timeStyle: 'medium' };
export const defaultDateTimeFormatConfig: DateTimeFormatterConfig = {
  dateStyle: 'short',
  timeStyle: 'medium',
};

// For custom formatting (based on formatting masks over native Intl)
export const customDateTimeMask = {
  date: 'DD-MM-YYYY',
  time: 'HH:mm:ss',
  dateTime: 'DD-MM-YYYY HH:mm:ss',
  year: 'YYYY',
  monthName: 'MMMM',
  monthNameShort: 'MMM',
  dayName: 'dddd',
  dayNameShort: 'ddd',
};

export const FORMAT_ONE_DESIGN_DATE_PICKER = 'dd-MMM-yyyy';
